import { render, staticRenderFns } from "./ExpanderCard.vue?vue&type=template&id=56f527c2&"
import script from "./ExpanderCard.vue?vue&type=script&lang=js&"
export * from "./ExpanderCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpanderCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports